import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  list: []
};

export default {
  state,
  getters,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/doctor/index.js